import { create } from 'zustand';

const initialState = {
  width: '650px',
  isOpen: false,
  maxWidth: '650px',
  type: '',
  title: '',
  contentTitle: '',
  contentDescription: '',
  contentHtmlDescription: '',
  showPrimaryButton: true,
  primaryButtonText: 'Simpan',
  onClickPrimaryButton: () => {},
  showSecondaryButton: true,
  secondaryButtonText: 'Tutup',
  onClickSecondaryButton: null,
  otherContent: <></>,
  customOnCloseModal: () => {},
};

export const useModal = create((set) => {
  return {
    ...initialState,
    onOpenModal: (newState) => set((state) => ({ ...state, ...newState })),
    onResetModal: () => set(() => initialState),
    onHideModal: () => set(() => ({ ...initialState, isOpen: false })),
    onShowModal: () => set(() => ({ ...initialState, isOpen: true })),
  };
});
